"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webapi_1 = require("@fegobull/webapi");
const element_ui_1 = require("element-ui");
const vue_demi_1 = require("vue-demi");
const utils_1 = require("../../common/utils");
const { usePageType, useTeleport } = webapi_1.use;
useTeleport(document.body);
exports.default = (0, vue_demi_1.defineComponent)({
    name: 'PopupSelect',
    components: {
        ElSelect: element_ui_1.Select,
        ElOption: element_ui_1.Option
    },
    props: {
        value: {
            type: [String, Number, Array],
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    emits: ['input', 'change'],
    setup(props, { emit }) {
        const { isPC } = usePageType();
        const popupVisible = (0, vue_demi_1.ref)(false);
        const contentRef = (0, vue_demi_1.ref)(null);
        const tempValue = (0, vue_demi_1.ref)(props.value);
        // 本地值（用于 v-model）
        const localValue = (0, vue_demi_1.computed)({
            get: () => props.value,
            set: (val) => {
                emit('input', val);
            }
        });
        // 显示文本
        const displayText = (0, vue_demi_1.computed)(() => {
            if (props.multiple) {
                const selectedOptions = props.options.filter((opt) => {
                    if (Array.isArray(props.value)) {
                        return props.value.includes(opt.value);
                    }
                    return false;
                });
                if (selectedOptions.length === 0) {
                    return props.placeholder;
                }
                return selectedOptions.map((opt) => opt.label).join(', ');
            }
            if (!props.value) {
                return props.placeholder;
            }
            const selectedOption = props.options.find((opt) => opt.value === props.value);
            return selectedOption ? selectedOption.label : props.placeholder;
        });
        // 多语言文本
        const lang = (0, utils_1.getCurrentLang)();
        const cancelText = (0, vue_demi_1.computed)(() => {
            const texts = {
                0: '取消', // CN
                1: '取消', // HK
                2: 'Cancel', // EN
                5: 'キャンセル' // JA
            };
            return texts[lang] || texts[0];
        });
        const confirmText = (0, vue_demi_1.computed)(() => {
            const texts = {
                0: '确认', // CN
                1: '確認', // HK
                2: 'Confirm', // EN
                5: '確認' // JA
            };
            return texts[lang] || texts[0];
        });
        // 判断选项是否被选中
        const isSelected = (value) => {
            if (props.multiple) {
                if (Array.isArray(tempValue.value)) {
                    return tempValue.value.includes(value);
                }
                return false;
            }
            return tempValue.value === value;
        };
        // 处理触发点击
        const handleTriggerClick = () => {
            if (props.disabled) {
                return;
            }
            tempValue.value = props.value;
            popupVisible.value = true;
        };
        // 处理选项点击
        const handleItemClick = (item) => {
            if (item.disabled) {
                return;
            }
            if (props.multiple) {
                const currentValues = Array.isArray(tempValue.value) ? [...tempValue.value] : [];
                const index = currentValues.indexOf(item.value);
                if (index > -1) {
                    currentValues.splice(index, 1);
                }
                else {
                    currentValues.push(item.value);
                }
                tempValue.value = currentValues;
            }
            else {
                tempValue.value = item.value;
            }
        };
        // 处理确认
        const handleConfirm = () => {
            emit('input', tempValue.value);
            emit('change', tempValue.value);
            popupVisible.value = false;
        };
        // 处理取消
        const handleCancel = () => {
            tempValue.value = props.value;
            popupVisible.value = false;
        };
        // 处理原生 Select 的 change 事件
        const handleChange = (val) => {
            emit('change', val);
        };
        // 监听 value 变化
        (0, vue_demi_1.watch)(() => props.value, (newVal) => {
            tempValue.value = newVal;
        });
        return {
            isPC,
            popupVisible,
            contentRef,
            tempValue,
            localValue,
            displayText,
            cancelText,
            confirmText,
            isSelected,
            handleTriggerClick,
            handleItemClick,
            handleConfirm,
            handleCancel,
            handleChange
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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